"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributionSpiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function attributionSpiClient(networkClient) {
    return {
        sendAttributionEvent: async (message) => {
            networkClient.fireToTopic(data_lib_1.SUBMIT_ATTRIBUTION_TOPIC, message);
        },
    };
}
exports.attributionSpiClient = attributionSpiClient;
